import React, { forwardRef } from "react"
import { classNames } from "../../utils"
import { Block, BlockProps } from "../Block"

export type InlineFlexProps = BlockProps

export const InlineFlex = forwardRef<HTMLDivElement, InlineFlexProps>(
  function InlineFlex({ className, ...rest }, ref) {
    return (
      <Block
        className={classNames("inline-flex", className)}
        ref={ref}
        {...rest}
      />
    )
  },
)
